import { get } from "lodash";
import { httpCall } from "../../../../common/util";
import appConstants from "../../../../config/appConstants";

export const updateNoteSettings = (params) => {
  const updateNoteSettingsEndpoint = "/1.0/organization/notes/config";
  return httpCall({
    method: appConstants.httpMethod.PUT,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    url: updateNoteSettingsEndpoint,
    data: params
  });
};

export const fetchNoteSettings = (params) => {
  const fetchNoteSettingsEndpoint = "/1.0/organization/info";
  return httpCall({
    method: appConstants.httpMethod.GET,
    headers: { "Content-Type": "application/json" },
    url: fetchNoteSettingsEndpoint,
  });
};


